import React from "react";
import {injectIntl} from "react-intl";
import {connect} from "react-redux";

import {setAssignQuotePopupSearchText} from "../../../actions/assignPopupFunctions";

const AssignQuotePopupSearch = (props) => {

  const {setAssignQuotePopupSearchText, assignQuotePopupSearchText, intl} = props;

  const handleSearchInputChange = (event) => {
    setAssignQuotePopupSearchText(event.target.value)
  };

  const searchText = assignQuotePopupSearchText;

  return (
    <div className="ass-search">
      <input type="text" className={"ui-input search-input"
      + (searchText ? " search-input--no-icon" : "")
      + (searchText && searchText.length > 12 ? " search-input--with-close" : "")}
             value={searchText}
             onChange={handleSearchInputChange}
             placeholder={intl.formatMessage({id: "mobileMenu.searchPlaceholder"})}
      />
      <span className="search-icon"/>
      {searchText ? <button className={"ui-close search-close"}
                            onClick={() => handleSearchInputChange({target:{value: ""}})}/> : null}
    </div>
  )
};

const mapStateToProps = (store) => {
  return {
    assignQuotePopupSearchText: store.assignQuoteState.assignQuotePopupSearchText
  };
};

const mapDispatchToProps = {
  setAssignQuotePopupSearchText
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(AssignQuotePopupSearch)
)
